var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (false)?_c('ul',{attrs:{"id":"affiche_vars"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }